import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { CHILD_ISSUES_PANEL_TYPE } from '../../common/constants.tsx';
import { getChildIssuesPanelType } from '../../state/context/selectors.tsx';
import {
	type ReorderChildrenRequestAction,
	REORDER_CHILDREN_REQUEST,
} from '../../state/entities/actions.tsx';
import type { State } from '../../state/types.tsx';
import reorderChildren from './reorder-children.tsx';
import reorderClassicSubtasks from './reorder-subtasks.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	action$: ActionsObservable<ReorderChildrenRequestAction>,
	store: MiddlewareAPI<State>,
) =>
	action$.ofType(REORDER_CHILDREN_REQUEST).mergeMap((action) => {
		const state = store.getState();
		const panelType = getChildIssuesPanelType(state);

		switch (panelType) {
			case CHILD_ISSUES_PANEL_TYPE.CLASSIC_SUBTASKS:
				return reorderClassicSubtasks(state, action.payload);

			case CHILD_ISSUES_PANEL_TYPE.CHILDREN_ISSUES_PANEL:
				return reorderChildren(state, action.payload, action.meta);

			default:
				return Observable.empty<never>();
		}
	});
